export default (element, data) => {
  function getDiscountFromCookies() {
    // Helper function to get cookie by name
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    // Helper function to set session-based cookie (no expiration)
    function setCookie(name, value) {
      document.cookie = `${name}=${value};path=/`; // Session-based cookie
    }

    // Retrieve discount_code and dismissed_toasts cookies
    const discountCode = getCookie('discount_code');
    let dismissedToasts = getCookie('dismissed_toasts');

    // If dismissed_toasts exists, parse it into an array; otherwise, initialize an empty array
    dismissedToasts = dismissedToasts ? JSON.parse(dismissedToasts) : [];

    // If no discount_code cookie or it's already in dismissed_toasts, return false
    if (!discountCode || dismissedToasts.includes(discountCode)) {
      return false;
    }

    // Otherwise, add the discount_code to dismissed_toasts and update the cookie
    dismissedToasts.push(discountCode);
    setCookie('dismissed_toasts', JSON.stringify(dismissedToasts));

    // Return the discount_code to be used
    return discountCode;
  }

  // function checkDiscount(cart, code) {
  //   console.log('cart', cart);
  //   console.log('checkCartDiscount(cart, code)', checkCartDiscount(cart, code));
  //   console.log('checkProductDiscount(cart, code)', checkProductDiscount(cart, code));
  //   if (checkCartDiscount(cart, code)) return checkCartDiscount(cart, code);
  //   if (checkProductDiscount(cart, code)) return checkProductDiscount(cart, code);
  //   return false;
  // }

  // Function to check if discount code is applied in cart
  // function checkCartDiscount(cart, code) {
  //   // Assuming cart_level_discount_applications contains the discounts array
  //   return cart.cart_level_discount_applications.some((discount) => discount.title === code);
  // }

  // function checkProductDiscount(cart, code) {
  //   // Assuming Product contains the discounts array
  //   return cart.items.map((item) => item.discounts.some((discount) => discount.title === code)).length;
  // }

  const discountCode = getDiscountFromCookies();
  const notification = element.querySelector('[data-show-notification]');
  const textNotification = element.querySelector('[data-notification-text]');
  const closeNotification = element.querySelector('[data-notification-close]');
  const notificationError = element.querySelector('[data-error-notification]');
  const textNotificationError = element.querySelector('[data-error-notification-text]');
  const closeNotificationError = element.querySelector('[data-error-notification-close]');

  closeNotification.addEventListener('click', () => {
    notification.classList.add('hidden');
  });

  closeNotificationError.addEventListener('click', () => {
    notificationError.classList.add('hidden');
  });

  if (discountCode) {
    textNotification.textContent = textNotification.textContent.replace('%code', discountCode);
    textNotificationError.textContent = textNotificationError.textContent.replace('%code', discountCode);

    notification.classList.remove('hidden');
    setTimeout(() => {
      notification.classList.add('hidden');
    }, data.toastDuration * 1000);
    // Comment out cart validation for now. When empty cart, the discount data on cart object is blank as well.
    // This results in a unsuccessful message when email traffic comes in with an empty cart and the discount is not
    // applied until items are in cart
    // Proceed with the fetch if discountCode is valid and not dismissed
    // fetch('/cart.js')
    //   .then((response) => response.json())
    //   .then((cart) => {
    //     // Check if the discount is applied in cart_level_discount_applications
    //     const discountApplied = checkDiscount(cart, discountCode);

    //     if (discountApplied) {
    //       notification.classList.remove('hidden');
    //       setTimeout(() => {
    //         notification.classList.add('hidden');
    //       }, data.toastDuration * 1000);
    //     } else {
    //       notificationError.classList.remove('hidden');
    //       setTimeout(() => {
    //         notificationError.classList.add('hidden');
    //       }, data.toastDuration * 1000);
    //     }
    //   })
    //   .catch((error) => console.error('Error fetching cart:', error));
  }
};
